import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PolicyAndResourcesService from "../../components/policy-and-resources/PolicyAndResourcesService";

const initialState = {
	data: {},
	columnConfig: [],
	status: "idle",
};

export const fetchPolicyAndResourceDocuments = createAsyncThunk(
	"policyAndResourceDocuments",
	async () => {
		const response = await PolicyAndResourcesService.getPolicyAndResourceDocuments();
		return response;
	}
);

export const PolicyAndResourcesSlice = createSlice({
	name: "policyAndResources",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPolicyAndResourceDocuments.pending, (state) => {
				state.status = "loading";
			})
			.addCase(fetchPolicyAndResourceDocuments.fulfilled, (state, action) => {
				state.status = "idle";
				state.data = action.payload;
			});
	},
});

export const selectPolicyAndResourceDocuments = (state) => state.policyAndResources.data;
